import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../ajs-upgraded-providers';
import { FeatureService } from '../core/feature.service';
import { Feature } from '../shared/feature';

@Component({
  selector: 'rl-features-recommendation',
  templateUrl: './features-recommendation.component.html',
  styleUrls: ['./features-recommendation.component.scss', './features-recommendation.component-rtl.css']
})
export class FeaturesRecommendationComponent implements OnInit {

  busy : boolean = false; 
  canEdit : boolean = false;
  editPrivileges : string[] = ['FULFILL_ADMINISTRATION','LEGANTO_CONFIG_UTILITY'];
  featuresChange : {[code: string]: boolean} ={};
  features : Feature[] ;
  recommendedFeatures : String[];

  constructor(private featureService : FeatureService, private authService : AuthService) { }
     
  ngOnInit(): void {

    this.features = this.featureService.features;
    this.recommendedFeatures = this.featureService.recommendedFeatures;
    
    this.authService.verifyHasPrivilege(this.editPrivileges, function() {
      this.canEdit = true;
    }.bind(this));
  }

  toggleFeature(featureCode :string, toggle : boolean) : void{
    if(this.featuresChange[featureCode]){ 
        delete this.featuresChange[featureCode];
    } else {
        this.featuresChange[featureCode] = toggle;
    } 
  }
 
  save() : void{
    this.busy =true;
    this.featureService.updateFeatures(this.featuresChange).subscribe(()=>{ 
      window.location.reload();
    }); 
 
  }

}
